import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
import { TroubleshootingDirectory } from "troubleshooting";
import axios from "axios";
var DeviceTroubleshootingView = /** @class */ (function (_super) {
    tslib_1.__extends(DeviceTroubleshootingView, _super);
    function DeviceTroubleshootingView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.directory = null;
        _this.contentData = null;
        return _this;
    }
    Object.defineProperty(DeviceTroubleshootingView.prototype, "title", {
        get: function () {
            if (this.contentData != null)
                return this.contentData.title;
            return "";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DeviceTroubleshootingView.prototype, "html", {
        get: function () {
            if (this.contentData != null)
                return this.contentData.html;
            return "";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DeviceTroubleshootingView.prototype, "directoryHtml", {
        get: function () {
            if (this.directory != null)
                return this.directory.Html();
            return "";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DeviceTroubleshootingView.prototype, "directoryExists", {
        get: function () {
            if (this.directory != null)
                return this.directory.items.length > 0;
            return false;
        },
        enumerable: true,
        configurable: true
    });
    DeviceTroubleshootingView.prototype.navigate = function (htmlKey) {
        this.$router.push("/devices/" + this.device.serial + "/troubleshooting/?htmlKey=" + htmlKey);
    };
    DeviceTroubleshootingView.prototype.buttonClicked = function (event) {
        this.navigate(event.target.id);
        this.hideMenu();
    };
    DeviceTroubleshootingView.prototype.iconClicked = function () {
        var element = document.getElementById("menu");
        if (element != null) {
            if (element.style.display === "block")
                element.style.display = "none";
            else
                element.style.display = "block";
        }
    };
    DeviceTroubleshootingView.prototype.hideMenu = function () {
        var element = document.getElementById("menu");
        if (element != null)
            element.style.display = "none";
    };
    DeviceTroubleshootingView.prototype.bindElements = function (className) {
        var elements = document.getElementsByClassName(className);
        for (var i = 0; i < elements.length; i++)
            elements[i].addEventListener("click", this.buttonClicked);
    };
    DeviceTroubleshootingView.prototype.bindButtons = function () {
        this.bindElements("menu-item");
        this.bindElements("button-flat");
        this.bindElements("button-standard");
        this.bindElements("button-instructions");
    };
    DeviceTroubleshootingView.prototype.created = function () {
        this.loadDirectory();
        this.loadContent();
    };
    DeviceTroubleshootingView.prototype.routed = function () {
        this.loadContent();
    };
    DeviceTroubleshootingView.prototype.mounted = function () {
        this.bindButtons();
    };
    DeviceTroubleshootingView.prototype.updated = function () {
        this.bindButtons();
    };
    DeviceTroubleshootingView.prototype.loadDirectory = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = "content/htmlDirectory?series=" + this.device.series;
                        _a = this;
                        _b = TroubleshootingDirectory.bind;
                        return [4 /*yield*/, axios.get(url)];
                    case 1:
                        _a.directory = new (_b.apply(TroubleshootingDirectory, [void 0, (_c.sent()).data]))();
                        return [2 /*return*/];
                }
            });
        });
    };
    DeviceTroubleshootingView.prototype.loadContent = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = "content/htmlContent";
                        _a = this;
                        return [4 /*yield*/, axios.get(url, { params: { htmlKey: this.$router.currentRoute.query.htmlKey || "Root" } })];
                    case 1:
                        _a.contentData = (_b.sent()).data;
                        return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        Prop({ type: Object }),
        tslib_1.__metadata("design:type", Object)
    ], DeviceTroubleshootingView.prototype, "device", void 0);
    DeviceTroubleshootingView = tslib_1.__decorate([
        Component
    ], DeviceTroubleshootingView);
    return DeviceTroubleshootingView;
}(Vue));
export default DeviceTroubleshootingView;
